// HoC Lux – product page & header interactions

(function () {
  function initAll(root) {
    root = root || document;
    initLead(root);
    initAtc(root);
    initGallery(root);
    initAccordions(root);
    initHeader(root);
  }

  /* =============================
     LEAD TEXT TOGGLE
     ============================= */

  function initLead(scope) {
    var wrap = scope.querySelector('[data-hoc-lead]');
    if (!wrap) return;

    var content = wrap.querySelector('[data-hoc-lead-content]');
    var toggle = wrap.querySelector('[data-hoc-lead-toggle]');
    if (!content || !toggle) return;

    var expanded = false;

    function setState(next) {
      expanded = next;
      wrap.classList.toggle('is-expanded', expanded);
      toggle.textContent = expanded ? 'Sulje' : 'Lue lisää';
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    toggle.addEventListener('click', function () {
      setState(!expanded);
    });
  }

  /* =============================
     ADD TO CART PRESS STATE
     ============================= */

  function initAtc(scope) {
    var btn = scope.querySelector('.hoc-lux__atc');
    if (!btn) return;

    btn.addEventListener('mousedown', function () {
      btn.classList.add('is-pressed');
    });

    ['mouseup', 'mouseleave'].forEach(function (evt) {
      btn.addEventListener(evt, function () {
        btn.classList.remove('is-pressed');
      });
    });
  }

  /* =============================
     MOBILE/TABLET GALLERY SLIDER
     ============================= */

  function initGallery(scope) {
    var gallery = scope.querySelector('[data-hoc-gallery]');
    if (!gallery) return;

    var track = gallery.querySelector('[data-hoc-gallery-track]');
    var prev = gallery.querySelector('[data-hoc-gallery-prev]');
    var next = gallery.querySelector('[data-hoc-gallery-next]');
    if (!track || !prev || !next) return;

    var DISABLE_THRESHOLD = 5; // px-toleranssi alku- ja loppupäähän

    function updateNavStateFromPosition(position) {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll < 0) maxScroll = 0;

      var atStart = position <= DISABLE_THRESHOLD;
      var atEnd = position >= maxScroll - DISABLE_THRESHOLD;

      prev.classList.toggle('hoc-gallery__nav--disabled', atStart);
      next.classList.toggle('hoc-gallery__nav--disabled', atEnd);
    }

    function updateNavState() {
      updateNavStateFromPosition(track.scrollLeft || 0);
    }

    function scrollToOffset(dir) {
      var width = gallery.clientWidth || track.clientWidth;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll < 0) maxScroll = 0;

      var current = track.scrollLeft || 0;
      var target = current + dir * width;

      if (target < 0) target = 0;
      if (target > maxScroll) target = maxScroll;

      // Päivitä nuolten tila heti -> fade-out käynnistyy liikkeen kanssa
      updateNavStateFromPosition(target);

      try {
        track.scrollTo({ left: target, behavior: 'smooth' });
      } catch (e) {
        // Fallback ilman smooth-scrollia
        track.scrollLeft = target;
      }
    }

    prev.addEventListener('click', function () {
      if (prev.classList.contains('hoc-gallery__nav--disabled')) return;
      scrollToOffset(-1);
    });

    next.addEventListener('click', function () {
      if (next.classList.contains('hoc-gallery__nav--disabled')) return;
      scrollToOffset(1);
    });

    // Päivitä nuolten näkyvyys myös swipe-scrollauksessa
    track.addEventListener('scroll', updateNavState, { passive: true });

    // Alkutilla: ollaan ensimmäisessä kuvassa -> vasen nuoli piiloon / pois toiminnasta
    updateNavState();
  }

  /* =============================
     ACCORDION MODALS
     ============================= */

  var currentAccModal = null;

  function initAccordions(scope) {
    var triggers = scope.querySelectorAll('[data-hoc-acc-trigger]');
    if (!triggers.length) return;

    var modals = scope.querySelectorAll('[data-hoc-acc-modal]');
    if (!modals.length) return;

    function findModal(id) {
      for (var i = 0; i < modals.length; i++) {
        if (modals[i].getAttribute('data-hoc-acc-id') === id) return modals[i];
      }
      return null;
    }

    function openModal(modal) {
      if (!modal) return;
      currentAccModal = modal;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('hoc-acc-modal-open');
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (currentAccModal === modal) {
        currentAccModal = null;
      }
      document.documentElement.classList.remove('hoc-acc-modal-open');
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-hoc-acc-id');
        var modal = findModal(id);
        if (!modal) return;
        openModal(modal);
      });
    });

    modals.forEach(function (modal) {
      var backdrop = modal.querySelector('[data-hoc-acc-modal-backdrop]');
      var closeBtn = modal.querySelector('[data-hoc-acc-modal-close]');

      if (backdrop) {
        backdrop.addEventListener('click', function () {
          closeModal(modal);
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          closeModal(modal);
        });
      }
    });

    if (!document.documentElement.dataset.hocAccEscBound) {
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          if (currentAccModal) {
            closeModal(currentAccModal);
          }
        }
      });
      document.documentElement.dataset.hocAccEscBound = 'true';
    }
  }

  /* =============================
     LV-TYYLINEN HEADER & MENU
     ============================= */

  var headerInitialized = false;

  function initHeader(scope) {
    if (headerInitialized && scope !== document) return;

    var header = document.querySelector('[data-hoc-header]');
    var menu = document.querySelector('[data-hoc-header-menu]');
    var toggle = document.querySelector('[data-hoc-menu-toggle]');
    if (!header || !menu || !toggle) return;

    var closeBtn = document.querySelector('[data-hoc-header-menu-close]');
    var backdrop = document.querySelector('[data-hoc-header-menu-backdrop]');
    var buyrail = document.querySelector('.hoc-lux__buyrail'); // buyrail sivulla
    headerInitialized = true;

    var isOpen = false;
    var buyrailLocked = false;

    // Lukitaan buyrail siihen kohtaan, missä se on, kun menu avataan
    function lockBuyrail() {
      if (!buyrail || buyrailLocked) return;

      var rect = buyrail.getBoundingClientRect();

      // Talleta mahdolliset aiemmat inline-tyylit, jotta voidaan palauttaa
      buyrail.dataset.hocPrevPosition = buyrail.style.position || '';
      buyrail.dataset.hocPrevTop = buyrail.style.top || '';
      buyrail.dataset.hocPrevLeft = buyrail.style.left || '';
      buyrail.dataset.hocPrevWidth = buyrail.style.width || '';

      buyrail.style.position = 'fixed';
      buyrail.style.top = rect.top + 'px';
      buyrail.style.left = rect.left + 'px';
      buyrail.style.width = rect.width + 'px';

      buyrailLocked = true;
    }

    // Palautetaan buyrail takaisin stickyksi menun sulkeutuessa
    function unlockBuyrail() {
      if (!buyrail || !buyrailLocked) return;

      buyrail.style.position = buyrail.dataset.hocPrevPosition || '';
      buyrail.style.top = buyrail.dataset.hocPrevTop || '';
      buyrail.style.left = buyrail.dataset.hocPrevLeft || '';
      buyrail.style.width = buyrail.dataset.hocPrevWidth || '';

      delete buyrail.dataset.hocPrevPosition;
      delete buyrail.dataset.hocPrevTop;
      delete buyrail.dataset.hocPrevLeft;
      delete buyrail.dataset.hocPrevWidth;

      buyrailLocked = false;
    }

    // Aseta header + menu (avaus/sulku)
    function setState(open) {
      // Ennen kuin menutila otetaan käyttöön, lukitaan buyrail paikalleen
      if (open && !isOpen) {
        lockBuyrail();
      }

      isOpen = open;

      header.classList.toggle('hoc-header--menu-open', open);
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

      // Scroll-lock edelleen .hoc-menu-open-luokalla html:ssä
      document.documentElement.classList.toggle('hoc-menu-open', open);

      // Kun menu on auki, pidä header aina solidina
      if (open) {
        header.classList.add('hoc-header--solid');
      }

      // Kun menu suljetaan, palautetaan buyrail stickyksi
      if (!open) {
        unlockBuyrail();
      }
    }

    toggle.addEventListener('click', function () {
      setState(!isOpen);
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        setState(false);
      });
    }

    if (backdrop) {
      backdrop.addEventListener('click', function () {
        setState(false);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (!isOpen) return;
      if (event.key === 'Escape' || event.key === 'Esc') {
        setState(false);
      }
    });

    // -----------------------------------
    // HEADERIN TAUSTA SCROLL-SUUNNAN MUKAAN
    // -----------------------------------
    var lastScrollY = window.scrollY || 0;
    var SCROLL_THRESHOLD = 40; // kuinka pitkälle pitää olla skrollattu ennen kuin solid-tausta aktivoituu

    function handleScroll() {
      var currentY = window.scrollY || 0;
      var scrollingDown = currentY > lastScrollY;
      var scrollingUp = currentY < lastScrollY;

      // Jos menu auki, anna menutilan hallita ulkoasua
      if (isOpen) {
        lastScrollY = currentY;
        return;
      }

      if (currentY <= SCROLL_THRESHOLD) {
        // Aivan sivun yläosassa – läpinäkyvä header
        header.classList.remove('hoc-header--solid');
      } else if (scrollingUp) {
        // Skrollataan ylöspäin ja ollaan jo kauempana yläreunasta -> solid valkoinen tausta
        header.classList.add('hoc-header--solid');
      } else if (scrollingDown) {
        // Heti kun suunta vaihtuu alas, poistetaan solid, jotta header liukuu ylös transparenttina
        header.classList.remove('hoc-header--solid');
      }

      lastScrollY = currentY;
    }

    window.addEventListener('scroll', handleScroll, { passive: true });

    // Aseta oikea tila heti sivun latautuessa
    handleScroll();
  }

  // Init on load
  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  // Re-init in theme editor when section is loaded
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

